import { render, staticRenderFns } from "./ConfirmDeletePackage.vue?vue&type=template&id=8f9ae89a&scoped=true"
import script from "./ConfirmDeletePackage.vue?vue&type=script&lang=js"
export * from "./ConfirmDeletePackage.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDeletePackage.vue?vue&type=style&index=0&id=8f9ae89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9ae89a",
  null
  
)

export default component.exports